import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { riskZonesQueryKeys } from "./queryKeys"
import { useRiskZonesQuery } from "./useRiskZonesQueries"

export function useRiskZonesSurveys() {
    const { selectedNetwork } = useNetworksStateContext()
    const url = "surveys/"

    const queryKey = riskZonesQueryKeys["surveys"]({ selectedNetwork })

    return useRiskZonesQuery(
        url,
        queryKey,
        { selectedNetwork },
    )
}